import axios from "axios";
import config from './config.js'
import Storage from './components/utils/Storage';

const underSsl = (window?.location?.href || 'https://').substr(0, 'https://'.length) === 'https://';

const options = {
  baseURL: underSsl ? config.backend.baseURLssl : config.backend.baseURL,
  headers: {
    "Content-type": "application/json",
  }
};
//with credentials solo se su ssl
//const underSsl = config.backend.baseURL.substr(0, 'https://'.length) === 'https://';
if (underSsl) {
  options.withCredentials = true;
}

const instance = axios.create(options);


//manda access_token a tutte le richieste tranne accessoutente
instance.interceptors.request.use(function (config) {
  if (config.url !== '/anagrafica/auth/access_token') {
    config.headers.Authorization = 'Bearer ' + window.access_token;
  }
  return config;
});


const refreshAccessToken = () => {
  const data = {
    client_id: config.backend.client_id,
    client_secret: config.backend.client_secret,
    grant_type: 'refresh_token',
    refresh_token: Storage.getItem('refresh_token'),
  };
  return instance.post("/anagrafica/auth/refresh_token", data);
}

//se hai come risultato 401
instance.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config;
  if (error?.response?.status === 403) {
    //gestire il forbidden
    return error.response;
  }
  if (error?.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    try {
      const refreshReply = await refreshAccessToken();
      //Salva token aggiornati
      window.access_token = refreshReply.data.access_token;
      //rimanda richiesta
      originalRequest.headers.Authorization = 'Bearer ' + refreshReply.data.access_token;
      return axios(originalRequest)
    } catch (err) {
      //Se non riesci ad aggiore il token, sessione scaduta
      Storage.removeItem('current_user');
      window.location.reload();
      throw error;
    }
  } else {
    //rilancia gli errori che non sono il primo 401
    throw error;
  }

});

export default instance;